import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import GoogleAuthButton from '../components/GoogleAuthButton';
import { toast } from 'sonner';
import BrandSeal from '../components/BrandSeal';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const result = await register(email, password, name);
    
    if (result.success) {
      toast.success('Registration successful!');
      navigate('/products');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="heritage-page min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center">
            <BrandSeal compact />
            <h1 className="heritage-title mt-4 mb-2 text-5xl tracking-[0.08em]" data-testid="register-logo">Panchami</h1>
          </Link>
          <p className="text-[#6a5448]">Create your account to start shopping</p>
        </div>

        <div className="heritage-card rounded-sm p-8">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="register-form">
            <div>
              <Label htmlFor="name" className="text-[#1A1A1A]">Full Name</Label>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="heritage-input mt-2 rounded-none"
                data-testid="register-name-input"
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-[#1A1A1A]">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="heritage-input mt-2 rounded-none"
                data-testid="register-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[#1A1A1A]">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="heritage-input mt-2 rounded-none"
                data-testid="register-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="heritage-button w-full rounded-none font-medium uppercase tracking-[0.18em]"
              data-testid="register-submit-btn"
            >
              {loading ? 'Creating account...' : 'Create Account'}
            </Button>
          </form>

          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="heritage-divider w-full border-t"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="bg-[#faf5ec] px-2 text-[#6a5448]">Or continue with</span>
              </div>
            </div>

            <GoogleAuthButton mode="signup" />
          </div>

          <p className="mt-6 text-center text-[#6a5448]">
            Already have an account?{' '}
            <Link to="/login" className="text-[#8e755d] hover:underline" data-testid="login-link">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
